export default __webpack_public_path__ + "static/media/Group3.4bf155b9.svg";